<template>
  <div class="impersonating">
    You are currently impersonating
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.impersonating {
  background-color: black;
  top: 15px;
  color: white;
  right: 15px;
  padding: 10px;
  position: fixed;
  z-index: 100;
}
</style>
